export interface CategoryItem {
  slug: string;
  name: string;
  english: string;
  description: string;
  icon: string;
  count: number;
  image: string;
}

export const categories: CategoryItem[] = [
  {
    slug: 'yule',
    name: '娱乐瓜田',
    english: 'ENTERTAINMENT',
    description: '综艺、剧集、演出与艺人身边的动态，第一时间跟进首发线索。',
    icon: 'ri-movie-2-line',
    count: 986,
    image:
      'https://readdy.ai/api/search-image?query=Dark%20moody%20theater%20stage%20with%20single%20amber%20spotlight%20and%20drifting%20haze%2C%20cinematic%20night%20atmosphere%2C%20deep%20charcoal%20background%2C%20artistic%20editorial%20photography%2C%20high%20contrast&width=800&height=600&seq=shenye-cat-yule-01&orientation=landscape',
  },
  {
    slug: 'shangjie',
    name: '商界秘闻',
    english: 'BUSINESS',
    description: '融资、收购、门店与内部信，从公开材料里读出没公开的部分。',
    icon: 'ri-building-2-line',
    count: 612,
    image:
      'https://readdy.ai/api/search-image?query=Abstract%20dark%20city%20skyline%20at%20midnight%20with%20amber%20window%20lights%20and%20low%20fog%2C%20minimal%20geometric%20composition%2C%20deep%20charcoal%20tones%2C%20editorial%20night%20photography&width=800&height=600&seq=shenye-cat-shangjie-01&orientation=landscape',
  },
  {
    slug: 'keji',
    name: '科技内幕',
    english: 'TECH',
    description: '产品背后的取舍、供应链的缝隙与被砍掉项目的后续。',
    icon: 'ri-cpu-line',
    count: 538,
    image:
      'https://readdy.ai/api/search-image?query=Macro%20shot%20of%20circuit%20board%20chips%20glowing%20warm%20amber%20under%20dark%20ambient%20light%2C%20abstract%20technology%20texture%2C%20minimal%20deep%20black%20background%2C%20editorial%20macro%20photography&width=800&height=600&seq=shenye-cat-keji-01&orientation=landscape',
  },
  {
    slug: 'shehui',
    name: '社会观察',
    english: 'SOCIETY',
    description: '夜班人群、租房与通勤，用真实账本记录城市运转的底色。',
    icon: 'ri-community-line',
    count: 477,
    image:
      'https://readdy.ai/api/search-image?query=Rainy%20empty%20city%20street%20at%203am%20with%20warm%20amber%20streetlamp%20reflections%20on%20wet%20asphalt%2C%20moody%20minimal%20night%20photography%2C%20deep%20dark%20tones&width=800&height=600&seq=shenye-cat-shehui-01&orientation=landscape',
  },
  {
    slug: 'quannei',
    name: '圈内实录',
    english: 'INSIDER',
    description: '来自从业者的自述与复盘，讲述行业里没人写进稿子的那部分。',
    icon: 'ri-mic-line',
    count: 356,
    image:
      'https://readdy.ai/api/search-image?query=Cozy%20dark%20interview%20room%20with%20single%20warm%20desk%20lamp%2C%20notebook%20and%20recorder%20on%20wooden%20table%2C%20intimate%20editorial%20night%20photography%2C%20deep%20charcoal%20tones&width=800&height=600&seq=shenye-cat-quannei-01&orientation=landscape',
  },
  {
    slug: 'diantai',
    name: '深夜电台',
    english: 'RADIO',
    description: '给还没睡的人。来信、来电与那些白天说不出口的话。',
    icon: 'ri-radio-line',
    count: 291,
    image:
      'https://readdy.ai/api/search-image?query=Vintage%20radio%20and%20headphones%20on%20a%20dark%20desk%20lit%20by%20warm%20amber%20light%2C%20quiet%20late%20night%20mood%2C%20editorial%20still%20life%20photography%2C%20deep%20dark%20background&width=800&height=600&seq=shenye-cat-diantai-01&orientation=landscape',
  },
];